"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React, { useRef, Suspense, lazy } from "react"
import TopNavBar from "../../../components/common/TopNavBar"
import SnackbarMessage from "../../../components/common/SnackbarMessage"
import publicProviderMessageable from "../../../graphql/queries/publicProviderMessageable"
const IntendedForSection = lazy(
  () => import("../../../components/pages/group/IntendedForSection"),
)
const CohortsSection = lazy(
  () => import("../../../components/pages/group/CohortsSection"),
)
const ExpectSection = lazy(
  () => import("../../../components/pages/group/ExpectSection"),
)
const GroupLeaderSection = lazy(
  () => import("../../../components/pages/group/GroupLeaderSection"),
)
const BottomButtons = lazy(
  () => import("../../../components/pages/group/BottomButtons"),
)
const ReachOut = lazy(() => import("../../../components/pages/group/ReachOut"))

const PreviewAndPublishGroupBanner = lazy(
  () => import("../../../components/pages/group/PreviewAndPublishGroupBanner"),
)
const FooterSimple = lazy(() => import("../../../components/common/FooterSimple"))
import { useQuery } from "@apollo/client/react"

import GroupTitle from "../../../components/pages/group/GroupTitle"
import ImageMetaDataDescriptionTags from "../../../components/pages/group/ImageMetaDataDescriptionTags"
import { AUTH_ROLE_ZEST_ADMIN } from "../../../lib/constants"
import useSessionAttributes from "../../../lib/auth/useSessionAttributes"
import useGetMe from "../../../hooks/useGetMe"
const stylingCenterOfContainer =
  "flex flex-col items-center py-[30px] min-[600px]:py-4 min-[600px]:px-[20px] px-[10px]"
const stylingCenterOfContainerInner =
  "max-w-1100px  flex items-center justify-center w-full"
const FORM_ID = process.env.NEXT_PUBLIC_HIPAATIZER_CONTACT_THERAPIST_FORM

type PublicProviderMessageableData = {
  publicProviderMessageable?: {
    nodes?: Array<{ canMessage?: boolean }>
  }
}

export default function GroupDetail({
  group,
  groupId,
  groupLeaders,
  groupTags,
  // initialCohortsQuery,
  initCohortSessionInfoObj,
  groupsPrimaryProviderId,
  cohorts,
  cohortsTotalCount,
  isPublished,
  // firstCohort,
  // firstCohortId,
  firstCohortSessionInfo,
  groupType,
  groupScheduleBlurb,
  preview,
}) {
  const cohortsSectionDivRef = useRef(null)
  const { userId, providerId, authRole } = useSessionAttributes()
  const [{ me, isFullyOnboarded }] = useGetMe()
  const isGroupILead = groupsPrimaryProviderId == providerId
  const isLoggedIn = !!userId
  const groupLeaderUserId = group?.primaryProviderUserId
  const groupName = group?.name

  // Query for provider messaging capability
  const { data: publicProviderMessageableData } =
    useQuery<PublicProviderMessageableData>(publicProviderMessageable, {
      variables: { iProviderId: groupsPrimaryProviderId },
      skip: !groupsPrimaryProviderId,
    })
  const isProviderMessageable =
    publicProviderMessageableData?.publicProviderMessageable?.nodes?.[0]?.canMessage

  // if admin do not show preview
  const renderPreviewAndPublishGroupBanner = () => {
    if (authRole === AUTH_ROLE_ZEST_ADMIN) {
      if (isPublished) {
        return null
      } else {
        return (
          <div className="bg-gray h-20px justify-center items-center flex w-full">
            Not published
          </div>
        )
      }
    }
    return isPublished ? null : (
      <Suspense fallback={<div>Loading...</div>} key={"pub-banner"}>
        <PreviewAndPublishGroupBanner
          groupId={groupId}
          userId={userId}
          isPublished={isPublished}
          isFullyOnboarded={isFullyOnboarded}
        />
      </Suspense>
    )
  }

  return (
    <div className={"font-roboto tracking-3"}>
      <TopNavBar startingBackgroundSolid={true} />

      <div className={"font-roboto tracking-3"}>
        {groupsPrimaryProviderId == providerId
          ? renderPreviewAndPublishGroupBanner()
          : ""}
        <div className={`${stylingCenterOfContainer} mt-7 min-[600px]:mt-9 `}>
          <div className={`${stylingCenterOfContainerInner}`}>
            <GroupTitle group={group} />
          </div>
        </div>
        <div className={`${stylingCenterOfContainer}  mb-[35px]`}>
          <div className={`${stylingCenterOfContainerInner} flex-col`}>
            <ImageMetaDataDescriptionTags
              group={group}
              // groupScheduleBlurb={groupScheduleBlurb}
              // groupType={groupType}
              groupTags={groupTags}
              // firstCohortSessionInfo={firstCohortSessionInfo}
            />
          </div>
        </div>

        <Suspense fallback={<div>Loading...</div>} key="cohort-sec">
          <CohortsSection
            group={group}
            groupId={groupId}
            initialCohorts={cohorts}
            cohortsTotalCount={cohortsTotalCount}
            cohortsSectionDivRef={cohortsSectionDivRef}
            initCohortSessionInfoObj={initCohortSessionInfoObj}
            groupType={groupType}
            groupScheduleBlurb={groupScheduleBlurb}
            firstCohortSessionInfo={firstCohortSessionInfo}
            isLoggedIn={isLoggedIn}
            groupLeaderUserId={groupLeaderUserId}
            groupName={groupName}
            myProviderId={providerId}
            groupProviderId={groupsPrimaryProviderId}
            publicProviderMessageable={isProviderMessageable}
          />
        </Suspense>
        <Suspense fallback={<div>Loading...</div>} key={"intended-for"}>
          <div className={`${stylingCenterOfContainer} `}>
            <div
              className={`${stylingCenterOfContainerInner} min-[600px]:mt-[20px]`}
            >
              <IntendedForSection group={group} />
            </div>
          </div>
        </Suspense>
        <Suspense fallback={<div>Loading...</div>} key={"expect"}>
          <div
            className={`${stylingCenterOfContainer} bg-[#F0FF96] min-[600px]:bg-white`}
          >
            <div
              className={`${stylingCenterOfContainerInner} min-[600px]:mt-[40px]`}
            >
              <ExpectSection group={group} />
            </div>
          </div>
        </Suspense>
        <Suspense fallback={<div>Loading...</div>} key={"leader"}>
          <div className={`${stylingCenterOfContainer}`}>
            <div
              className={`${stylingCenterOfContainerInner}  min-[600px]:mt-[40px]`}
            >
              <GroupLeaderSection
                group={group}
                groupLeaders={groupLeaders}
                isGroupILead={isGroupILead}
                me={me}
                preview={preview}
              />
            </div>
          </div>
        </Suspense>
        <Suspense fallback={<div>Loading...</div>} key={"bottom-buttons"}>
          <div className={`${stylingCenterOfContainer}`}>
            <div className={`${stylingCenterOfContainerInner}  `}>
              <BottomButtons
                cohortsTotalCount={cohortsTotalCount}
                cohortsSectionDivRef={cohortsSectionDivRef}
              />
            </div>
          </div>
        </Suspense>
        <Suspense fallback={<div>Loading...</div>} key={"reach-out"}>
          <ReachOut
            group={group}
            me={me}
            isLoggedIn={isLoggedIn}
            groupLeaderUserId={groupLeaderUserId}
            groupName={groupName}
            formId={FORM_ID}
            publicProviderMessageable={isProviderMessageable}
          />
        </Suspense>

        <div className={"h-[100px]"} />
        <Suspense fallback={<div>Loading...</div>} key={`footer`}>
          <FooterSimple />
        </Suspense>
      </div>

      <SnackbarMessage />
    </div>
  )
}
